<div class="color-picker">
	<div *ngIf="show" class="opened">
		<div class="colors">
			<div
				(click)="changeColor(paint)"
				*ngFor="let paint of colorList != null && colorList.length > 0 ? colorList : defaultColors"
				class="circle"
				[ngStyle]="{ background: paint }"
			></div>
		</div>
		<hr />
		<button mat-stroked-button style="width: 100%;" (click)="toggleColors()">Annuler</button>
	</div>
</div>
